import * as React from "react";
import {AccordionItem, AccordionItemProps} from "shared/controls/Accordion/AccordionItem";

export class Accordion extends React.Component<AccordionProps, AccordionState> {
    static defaultProps: Partial<AccordionProps> = {
        OpenOnlyOne:true
    };
    Items:AccordionInternalItem[]=[];
    constructor(props: AccordionProps) {
        super(props);
        this.state = {};
        this.UpdateItems();
    }

    componentWillReceiveProps(nextProps: Readonly<AccordionProps>, nextContext: any): void {
        this.UpdateItems(React.Children.toArray((nextProps as any).children) as any[]);
    }


    public render() {
        return (
            <div className={'rnAccordion'}>
                {this.Items.map((x,y)=>
                    <AccordionItem key={y} {...x.Item.props} IsOpen={x.IsOpen} IsOpenChanging={(e)=>{if(e&&this.props.OpenOnlyOne)this.CloseOtherItems(x,e)}}/>
                )}
            </div>
        )
    }

    private CloseOtherItems(x: AccordionInternalItem,isOpen:boolean) {
        for(let item of this.Items)
            if(item.Item==x.Item)
            {
                continue;
            }else
                item.IsOpen=false;

        x.IsOpen=isOpen as boolean;
    }

    private UpdateItems(list:any[]=null) {
        if(list==null)
            list=React.Children.toArray(this.props.children) as any[];
        this.Items=[];
        for(let item of list)
            this.Items.push(new AccordionInternalItem(item,item.props.IsOpen,));

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface AccordionProps {
    OpenOnlyOne:boolean;
}

interface AccordionState {

}


class AccordionInternalItem {
    Item:AccordionItem;

    IsOpen:boolean;

    constructor(Item:AccordionItem,IsOpen:boolean){
        this.Item=Item;
        this.IsOpen=IsOpen;
    }
}

//#endregion "My Region"